import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AccessDenied from "./AccessDenied";

/**
 * PageGuard — route-level enforcement for the 3-tier admin-level system.
 *
 *   HIDDEN                → redirect to the shell's dashboard
 *   VISIBLE_ACCESS_DENIED → render the AccessDenied panel (nav stays visible)
 *   VISIBLE_ACCESSIBLE    → render children
 *
 * Usage:
 *   <PageGuard pageKey="payroll" pageLabel="Payroll">
 *     <PayrollPage />
 *   </PageGuard>
 *
 * `redirectTo` lets each shell target its own dashboard route
 * (e.g. "/dashboard/dashboard" for the admin shell).
 */
const PageGuard = ({ pageKey, pageLabel, redirectTo = "/dashboard", children }) => {
  const { getPageState } = useAuth();

  // No pageKey → page is not part of the permission system (always allowed)
  if (!pageKey) return children;

  const state = getPageState(pageKey);
  if (state === "HIDDEN") {
    return <Navigate to={redirectTo} replace />;
  }
  if (state === "VISIBLE_ACCESS_DENIED") {
    return <AccessDenied pageLabel={pageLabel} />;
  }
  return children;
};

export default PageGuard;
